// extracted by css-extract-rspack-plugin
var _1 = "EONRChphS5UQzg_j";
export { _1 as "row" }
